module.exports = __webpack_public_path__ + "static/media/printing-services-img14.96fc97eb.jpg";